import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Card, CardContent, TextField, Button, Typography,
  Alert, CircularProgress, InputAdornment, IconButton
} from '@mui/material';
import WifiIcon        from '@mui/icons-material/Wifi';
import Visibility      from '@mui/icons-material/Visibility';
import VisibilityOff   from '@mui/icons-material/VisibilityOff';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const { login }             = useAuth();
  const navigate              = useNavigate();
  const [email, setEmail]     = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(email, password);
      navigate('/');
    } catch {
      setError('Email ou mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', bgcolor: '#1F4E79',
      background: 'linear-gradient(135deg, #1F4E79 0%, #2E75B6 100%)'
    }}>
      <Card sx={{ width: '100%', maxWidth: 400, mx: 2, borderRadius: 3,
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Box sx={{ display: 'inline-flex', alignItems: 'center',
              justifyContent: 'center', width: 64, height: 64,
              borderRadius: '50%', bgcolor: '#1F4E79', mb: 2 }}>
              <img src="/logo-redia.jpg" alt="REDIA" style={{width:48,height:48,objectFit:"contain"}} />
            </Box>
            <Typography variant="h5" fontWeight={700} color="#1F4E79">
              REDIA Tools
            </Typography>
            <Typography variant="body2" color="text.secondary" mt={0.5}>
              WiFi Tracker — Outil Technicien
            </Typography>
          </Box>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth label="Email" type="email" value={email}
              onChange={e => setEmail(e.target.value)}
              required sx={{ mb: 2 }} autoFocus
            />
            <TextField
              fullWidth label="Mot de passe"
              type={showPwd ? 'text' : 'password'}
              value={password} onChange={e => setPassword(e.target.value)}
              required sx={{ mb: 3 }}
              InputProps={{ endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPwd(!showPwd)} edge="end">
                    {showPwd ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )}}
            />
            <Button fullWidth variant="contained" type="submit"
              disabled={loading} size="large"
              sx={{ py: 1.5, borderRadius: 2, fontWeight: 600,
                bgcolor: '#1F4E79', '&:hover': { bgcolor: '#163a5f' }}}>
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Se connecter'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
